import React, {useContext, useEffect, useState} from 'react';
import {Col, Container, Form, Row} from "react-bootstrap";
import {EntityAccountsComponent} from "components/entity-accounts/EntityAccountsComponent";
import {WireTemplatesContext} from "./context";
import {EntityAccountsContext} from "components/entity-accounts/context";
import * as URL from "service/UrlConstant";
import {SecurityContext} from "context/security";
import {ToastContext} from "context/Toast";
import {dateToString, getCurBusDate, getMinPermissibleBusDate, pickerDateFormatToDate} from "utils/FormatUtils";
import {isValidDate} from "../../../utils/RegexUtils";
import {VALIDATION_IN_JS} from "../../../utils/Constants";
import {
    updateTradesFilterFormErrors as updateMnyWiresTempFilterFormErrors
} from "../../../utils/ErrorUtils";
import AddNewWireTemplateStep1 from "./AddNewWireTemplateStep1";
import {useHistory} from "react-router-dom";
import {WIRE_TEMPLATE_NEW_STEP1} from "../../../routes/Routes";
import {ActionPanelContext} from "../../../context/action";

export default function WireTemplatesFilter() {

    const {wireTemplatePanelFilterState,wireTemplateResultsDisplayState,
        setWireTemplateResultsDisplayState, setWireTemplatePanelFilterState,
        clearWireTemplatePanelDisplayState, displayWireTemplatePanelPage,
        displayWireTemplateActionState,addWireTemplateState, setAddWireTemplateState,
        TEMPLATE_PANEL_SEARCH_PAGE, initAddWireTemplateState} = useContext(WireTemplatesContext)
    const {clearEntityAccounts, entityAccountsNoSwap, populateDefaultEntity, entityAccountsOptionsNoSwap, validateEntityAccountSearch, setManagerDetails} = useContext(EntityAccountsContext);
    const {makePostRequest} = useContext(SecurityContext);
    const {setDefaultStatus} = useContext(ActionPanelContext)
    const {error} = useContext(ToastContext);
    const [formErrors, setFormErrors] = useState({});

    const [showAddTemplate, setShowAddTemplate] = useState(false);
    let history = useHistory();
    function navigateToPage(path) {
        history.push(path);
    }

    useEffect(() => {
        // populateDefaultEntity(true,true)
        // set ALL in entity list
        setManagerDetails(-1, 'ALL', true)
    }, [entityAccountsOptionsNoSwap])

    const handleClear = (e) => {
        e.preventDefault();
        clearEntityAccounts(undefined,undefined,true)
        clearWireTemplatePanelDisplayState()
    }

    const validateSearch = ()=>{
        const {startDate, endDate} = wireTemplatePanelFilterState;
        let errors = {}
        errors = validateEntityAccountSearch(false,true);


        if (startDate && endDate){
            let startDateD = new Date(startDate).getTime();
            let endDateD = new Date(endDate).getTime();

            if (startDateD > endDateD){
                errors['startDate'] = 'Please ensure that the start date is before the end date'
                errors['endDate'] = 'Please ensure that the start date is before the end date'
            }
        }

        if (startDate && (dateToString(startDate) < getMinPermissibleBusDate()))
            errors['startDate'] = `Please ensure that the start date is on or after ${pickerDateFormatToDate(getMinPermissibleBusDate())}`;

        if (startDate &&  (dateToString(startDate) > getCurBusDate()))
            errors['startDate'] = `Please ensure that the start date is on or before ${pickerDateFormatToDate(getCurBusDate())}`;
        if (startDate &&  (dateToString(endDate) > getCurBusDate()))
            errors['endDate'] = `Please ensure that the end date is on or before ${pickerDateFormatToDate(getCurBusDate())}`;


        return errors
    }

    const handleRefresh = (e) => {
        e.preventDefault();

        let errors = {}
        if (VALIDATION_IN_JS) {
            errors = validateSearch()
        }
        if(Object.keys(errors).length > 0){
            setFormErrors(errors)
            return
        }

        const params = {
            managerId: entityAccountsNoSwap.managerId,
            accountId: entityAccountsNoSwap.accountId,
            status: wireTemplatePanelFilterState.status,
            dtStart: wireTemplatePanelFilterState.startDate ? dateToString(wireTemplatePanelFilterState.startDate) : null,
            dtEnd: wireTemplatePanelFilterState.endDate ? dateToString(wireTemplatePanelFilterState.endDate) : null
        }

        const onSuccessResponse = (response) => {
            const wireTemplateDisplayState = JSON.parse(JSON.stringify(wireTemplateResultsDisplayState))
            wireTemplateDisplayState.resData = ([...response.data])
            setDefaultStatus(wireTemplatePanelFilterState.status?wireTemplatePanelFilterState.status:'ALL')
            setWireTemplateResultsDisplayState(wireTemplateDisplayState);
            displayWireTemplatePanelPage(TEMPLATE_PANEL_SEARCH_PAGE);
        }
        const onErrorResponse = (err) => {
            console.error(err);
            error("Error refreshing templates")
        }

        makePostRequest(params,
            URL.WIRE_TEMPLATE_SEARCH_URL , onSuccessResponse, onErrorResponse);
    }

    const handleChange = (e) => {
        const targetName = e.currentTarget.name;
        const targetValue = e.currentTarget.value;
        const wireTemplatePanelFilterStateDetail = JSON.parse(JSON.stringify(wireTemplatePanelFilterState));
        wireTemplatePanelFilterStateDetail[targetName] = targetValue
        setWireTemplatePanelFilterState(wireTemplatePanelFilterStateDetail);

        updateMnyWiresTempFilterFormErrors(targetName, targetValue, formErrors,
            setFormErrors, wireTemplatePanelFilterState);

    }

    const onAddTemplateClicked = () => {
        setShowAddTemplate(true);
        displayWireTemplateActionState("")

        setAddWireTemplateState({...initAddWireTemplateState,
            'managerId': entityAccountsNoSwap.managerId,
            'managerName': entityAccountsNoSwap.managerName,
            'accountId': entityAccountsNoSwap.accountId,
            'accountName': entityAccountsNoSwap.accountName,
            'accountCode': entityAccountsNoSwap.accountCode});
        navigateToPage(WIRE_TEMPLATE_NEW_STEP1)
    }


    return(<>

        <Container fluid className="mt-md-3 mt-sm-0">
            <Form>
                <h2 className="d-md-block d-none">Search</h2>
                <Row>
                    <EntityAccountsComponent entityOptional={true} accountOptional={true} addAllInEntity={true} hideSwapLob={true}/>

                    <Col sm={12} md={12}>
                        <Form.Group controlId="formMnyWiresStatus" className={'td-select'}>
                            <Form.Label className="filter-input-label">Status</Form.Label>
                            <Form.Control as="select" name ='status' value={wireTemplatePanelFilterState.status} onChange={event => handleChange(event, 'status')}>
                                <option value={'ALL'}>ALL</option>
                                <option value={"PEND"}>Pending</option>
                                <option value={"APPROVE"}>Approved</option>
                                <option value={"REJECT"}>Rejected</option>
                                <option value={"DELETE"}>Deleted</option>
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col sm={6} md={12}>
                        <Form.Group controlId="formWireTemplateStartDate">
                            <Form.Label className="filter-input-label">Start Date</Form.Label>
                            <Form.Control type="date" name={'startDate'} value={wireTemplatePanelFilterState.startDate} onChange={handleChange} isInvalid={!!formErrors.startDate}/>
                            <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.startDate}</b></Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col sm={6} md={12}>
                        <Form.Group controlId="formWireTemplateEndDate">
                            <Form.Label className="filter-input-label">End Date</Form.Label>
                            <Form.Control type="date" name={'endDate'} value={wireTemplatePanelFilterState.endDate} onChange={handleChange} isInvalid={!!formErrors.endDate}/>
                            <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.endDate}</b></Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <button className="btn btn-block td-btn-primary-light my-3" onClick={handleRefresh}>Refresh</button>
                    </Col>
                    <Col md={12}>
                        <button className="btn btn-block td-btn-secondary-clear my-3" onClick={handleClear}>Clear</button>
                    </Col>
                    <Col md={12}>
                        <a className="btn btn-block td-btn-primary-light my-3" onClick={onAddTemplateClicked}>Add Template</a>
                    </Col>
                </Row>
            </Form>

        </Container>

    </>);}